import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Card,
} from "react-bootstrap";
import { signUp, resetSignUp } from "../../actions/auth-action";
import { Link, Redirect } from "react-router-dom";
import "./SignUp.scss";
import "./Login.scss"; // Import Login styles for the redesign
import useInput from "../hooks/useInput";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import Header from "../common/HeaderGuest";
import Footer from "../common/Footer";
import { t } from "i18next";
import { Trans, useTranslation } from "react-i18next";
import HeaderGuest from "../common/HeaderGuest";
import GuestContainer from "./GuestContainer";
import { toast } from "react-toastify";
import AuthLogo from "./AuthLogo";
import AppDownloadBanner from "../common/AppDownloadBanner";

const SignUp = (props) => {
  const { signUp, resetSignUp } = props;
  const { search } = useLocation();
  const query = queryString.parse(search);
  const {t} = useTranslation()

  const signUpError = useSelector((state) => state.auth.signUpError);
  const signUpRedirect = useSelector((state) => state.auth.signUpRedirect);
  const signUpStart = useSelector((state) => state.auth.signUpStart);
  const signUpSuccess = useSelector((state) => state.auth.signUpSuccess);

  const [firstName, setFirstName] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPass, setConfirmPass] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [referralCode, bindReferralCode] = useState(query.ref || "");
  const [checked, setChecked] = useState(false);
  const alphaNumericSpaceRegex = /^[A-Za-z0-9\s]*$/;


  useEffect(() => {
    resetSignUp();
    return () => {
      resetSignUp();
    };
  }, []);

  const handleLength = (callback,value,maxLength)=>{
    return callback(value.slice(0, maxLength));
  }
  const handleChange = (input) => {
    setFirstName(input);

    // Check if text contains any URL
    setIsValid(alphaNumericSpaceRegex.test(input));
  };

  const clickSignUp = (e) => {
    e.preventDefault();
    if(isValid === false){   
      toast.error("First name can only contain letters and spaces.");
      return;
    }
    signUp({
      first_name: firstName,
      email,
      password,
      password_confirmation: confirmPass,
      referral_code: referralCode,
      from: "web",
    });
  };
  if (signUpRedirect) {
    return <Redirect to="/bots" />;
  }
  return (
    <>
     <GuestContainer>
       <div className="login-redesign-container">
          <div className="login-left-panel">
            <div className="login-content">
              
              {/* Logo Section */}
              <div className="d-flex justify-content-center justify-content-lg-start">
                <AuthLogo />
              </div>

               {/* Header Section */}
               <div className="text-left mb-5">
                  {/* <h1 className="login-title">Create new account.</h1> */}
                  <p className="login-subtitle">Enter your details to sign up.</p>
               </div>

              <Form>
                
                {/* First Name */}
                <div className="login-input-group mb-3">
                  <img src="/images/icon-user.svg" className="input-icon" alt="User" />
                  <input
                    type="text" // Changed from 'input' to 'text' for standard HTML
                    placeholder={t("first-name")}
                    value={firstName}
                    onChange={(e) => handleChange(e.target.value)}
                    onKeyDown={(e)=>handleLength(setFirstName,e.target.value,100)}
                    className="login-input-transparent form-control"
                  />
                </div>
                 {!isValid && (
                      <p style={{ color: 'red',textAlign: 'left', marginLeft: '10px', fontSize: '12px' }}>
                        First name can only contain letters and spaces.
                      </p>
                    )}

                {/* Email */}
                <div className="login-input-group mb-3">
                  <img src="/images/email_icon_new.svg" className="input-icon" alt="Email" />
                  <input
                    type="email"
                    placeholder={t("email")}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyDown={(e)=>handleLength(setEmail,e.target.value,200)}
                    className="login-input-transparent form-control"
                  />
                </div>

                {/* Password */}
                <div className="login-input-group mb-3">
                  <img src="/images/password_icon_new.svg" className="input-icon" alt="Lock" />
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder={t("Password")}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={(e)=>handleLength(setPassword,e.target.value,50)}
                    className="login-input-transparent form-control"
                  />
                  {/* Eye icon placeholder for consistency */}
                  <span className="password-toggle-icon" onClick={() => setShowPassword(!showPassword)}>
                     <i className={`fa-regular ${showPassword ? "fa-eye" : "fa-eye-slash"}`} style={{color: '#333'}}></i>
                  </span>
                </div>

                {/* Confirm Password */}
                <div className="login-input-group mb-3">
                   <img src="/images/password_icon_new.svg" className="input-icon" alt="Lock" />
                   <input
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder={t("re-pass")}
                    value={confirmPass}
                    onChange={(e) => setConfirmPass(e.target.value)}
                    onKeyDown={(e)=>handleLength(setConfirmPass,e.target.value,50)}
                    className="login-input-transparent form-control"
                  />
                   {/* Eye icon placeholder for consistency */}
                  <span className="password-toggle-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                     <i className={`fa-regular ${showConfirmPassword ? "fa-eye" : "fa-eye-slash"}`} style={{color: '#333'}}></i>
                  </span>
                </div>

                {/* Referral Code */}
                <div className="login-input-group mb-3">
                   <img src="/images/icon-referral.svg" className="input-icon" alt="Referral" />
                   <input
                    type="text"
                    placeholder={t("ref-code")}
                    value={referralCode}
                    onChange={(e) => bindReferralCode(e.target.value)}
                    disabled={query.ref != null}
                    onKeyDown={(e)=>handleLength(bindReferralCode,e.target.value,10)}
                    className="login-input-transparent form-control"
                  />
                </div>
                
                {/* Checkbox */}
                <div className="signup-checkbox" style={{ display: 'flex', alignItems: 'center', marginBottom: '2rem' }}>
                <input type="checkbox" id="one" className=""  
                  value={checked}
                  onChange={(e) => setChecked(e.target.checked)}>
                </input>
                <label htmlFor="one" className="" style={{ marginLeft: '10px' }}>{
                  <>
                    <Trans i18nKey={"i-agree"}>
                    <a
                      href="https://www.stockhero.ai/terms.html"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                    </a>
                    </Trans>
                  </>
                  
                  }</label>
                </div>
               
                
               
                <button type="submit" onClick={clickSignUp} className="btn-login-new" disabled={!checked}>
                  {signUpStart ? "SUBMITTING..." : "SIGN UP"}
                </button>
                  
                <Alert
                  show={signUpError != null || signUpSuccess}
                  variant={signUpSuccess ? "success" : "danger"}
                  className="mt-2"
                >
                 {signUpError || t("acc-created-msg")}
                </Alert>
              </Form>

              <div className="text-center mt-4 login-content-bottom-link">
                 <p className="mb-0">
                    {t("have-acc")} <Link to="/login" className="link-text font-weight-bold" style={{color: '#007bff'}}>{t("login")}</Link>
                 </p>
              </div>

            </div>
          </div>

           <div className="login-right-panel d-none d-lg-block">
                <div className="hero-image-wrapper">
                    <img src="/images/new-login-bg.png" alt="Login Hero" />
                    <div className="auth-hero-download">
                      <AppDownloadBanner variant="auth" />
                    </div>
                </div>
          </div>

       </div>
     </GuestContainer>
    </>
  );
};

export default connect(null, { signUp, resetSignUp })(SignUp);
